// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IUpdateAccountModel {
    static getAttributeTypeMap() {
        return IUpdateAccountModel.attributeTypeMap;
    }
}
IUpdateAccountModel.discriminator = undefined;
IUpdateAccountModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    }
];
//# sourceMappingURL=iUpdateAccountModel.js.map